<template>
  <eg-radio-checkbox-input type="checkbox" v-bind="$attrs" v-on="$listeners">
    <template
      v-if="$slots['content'] || $scopedSlots['content']"
      #content="slotProps"
    >
      <slot name="content" v-bind="slotProps" />
    </template>
  </eg-radio-checkbox-input>
</template>

<script>
import EgRadioCheckboxInput from "./eg_radio_checkbox_input.vue";
export default {
  name: "EgRadioInput",
  components: {
    EgRadioCheckboxInput,
  },
};
</script>
